'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var button = require('./button-c50f4784.js');
var paymentMethodsManager_interface = require('./payment-methods-manager.interface-3aafedbf.js');

var StyledButton = styled__default(button.Button)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  font: 500 16px/24px ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  padding-left: 0px;\n\n  .button-content {\n    justify-content: flex-start;\n  }\n"], ["\n  font: 500 16px/24px ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  padding-left: 0px;\n\n  .button-content {\n    justify-content: flex-start;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var templateObject_1;

var AddCardButton = function (_a) {
    var paymentMethods = _a.paymentMethods, onAddNewCard = _a.onAddNewCard, addCardButtonText = _a.addCardButtonText, isDisabled = _a.isDisabled;
    if ((paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) === 1 && (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods[0].payment_method_type) === paymentMethodsManager_interface.INVOICE) {
        return null;
    }
    return (React__default.createElement(StyledButton, { variant: "link", text: addCardButtonText, disabled: isDisabled, "data-testid": "add-new-card-button", onClick: onAddNewCard }));
};

exports.AddCardButton = AddCardButton;
